<div class="wrapper mat-menu-panel" cdkDropList (cdkDropListDropped)="drop($event)">
    <div class="mat-menu-item">
        <mat-icon></mat-icon>
        <mat-checkbox [checked]="allSelected" (change)="selectAll()">Select All</mat-checkbox>
    </div>
    <mat-divider></mat-divider>
    <div class="mat-menu-item" cdkDrag *ngFor="let option of menuOptions">
        <mat-icon>drag_handle</mat-icon>
        <mat-checkbox [checked]="option.selected" (change)="toggleSelect(option)">{{option.option}}</mat-checkbox>
    </div>
</div>
